import { render, staticRenderFns } from "./MyApplication.vue?vue&type=template&id=937a1208&scoped=true&"
import script from "./MyApplication.vue?vue&type=script&lang=js&"
export * from "./MyApplication.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "937a1208",
  null
  
)

export default component.exports